import { useReactFlow, useStoreApi } from '@xyflow/react';
import { useEffect, useRef } from 'react';

export const useForwardPinchToSweepCanvas = ({ element }: { element: HTMLElement | null }) => {
  const { getZoom, zoomTo } = useReactFlow();

  const currentEEventHandler = useRef<((e: WheelEvent) => void) | null>(null);
  const store = useStoreApi();

  useEffect(() => {
    if (!element) {
      return;
    }

    if (currentEEventHandler.current) {
      element.removeEventListener('wheel', currentEEventHandler.current);
    }
    currentEEventHandler.current = (e: WheelEvent) => {
      e.stopPropagation();
      e.preventDefault();

      const domNode = store.getState().domNode;
      const reactFlowRendererDiv = domNode?.querySelector('.react-flow__renderer');

      if (reactFlowRendererDiv) {
        reactFlowRendererDiv.dispatchEvent(new WheelEvent('wheel', e));
      }
    };

    element.addEventListener('wheel', currentEEventHandler.current, {
      passive: false,
      capture: true,
    });

    return () => {
      if (currentEEventHandler.current) {
        element.removeEventListener('wheel', currentEEventHandler.current);
      }
    };
  }, [element, getZoom, store, zoomTo]);
};
